<template>
  <div class='mainContainer' v-loading='importLoading'>
    <div class='nav'>
      <el-form :model='searchForm' label-width='90px' :inline='true'>
        <el-form-item label='登录账号：'>
          <el-input v-model='searchForm.account' size='mini' placeholder='请输入登录账号' />
        </el-form-item>
        <el-form-item label='姓名：'>
          <el-input v-model='searchForm.empNm' size='mini' placeholder='请输入姓名' />
        </el-form-item>
        <el-form-item label='角色：'>
          <el-input v-model='searchForm.roleNm' size='mini' placeholder='请输入角色' />
        </el-form-item>
        <el-form-item label='部门：'>
          <el-input v-model='searchForm.depNm' size='mini' placeholder='请输入部门' />
        </el-form-item>
        <el-form-item label='用户类型：'>
          <el-select v-model='searchForm.source' filterable size='mini' placeholder='请选择用户类型'>
            <el-option v-for='item in sourceOption' :key='item.name' :label='item.name'
                       :value='item.id' />
          </el-select>
        </el-form-item>
        <el-form-item label='状态：'>
          <el-select v-model='searchForm.isEnable' filterable size='mini' placeholder='请选择状态'>
            <el-option v-for='item in isEnableOption' :key='item.name' :label='item.name'
                       :value='item.id' />
          </el-select>
        </el-form-item>
      </el-form>
      <div class='navBtn'>
        <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
        <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
        <el-button size='small' type='primary' @click='addBtn'>新增</el-button>
      </div>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <span @click='download' class='pointer'>模板下载</span>
        <span style='cursor: pointer;display: inline-block;'>
          <batch-import :upload-url='importUrl' @importSuccess='searchBtn'
                        @triggerLoading='importLoading = !importLoading' />
        </span>
        <span @click='exportClick'>导出数据</span>
      </el-col>
    </el-row>
    <div class='content'>
      <el-table
        v-loading='tableLoad'
        :data='tableData'
        style='width: 100%'
        border
        stripe
        row-key='id'
        :header-cell-style='headerCellStyle'
        :cell-style='cellStyle'>
        <el-table-column type='index' label='序号' align='center' />
        <el-table-column label='账号' prop='account' align='center' />
        <el-table-column label='姓名' prop='empNm' width='260' align='center'>
          <template slot-scope='scope'>
            {{ scope.row.empNm === null ? '--' : scope.row.empNm }}
          </template>
        </el-table-column>
        <el-table-column label='所属公司' prop='full_name' align='center' show-overflow-tooltip>
          <template slot-scope='scope'>
            {{ scope.row.full_name === null ? '--' : scope.row.full_name }}
          </template>
        </el-table-column>
        <el-table-column label='用户类型' prop='source' align='center' show-overflow-tooltip>
          <template slot-scope='scope'>
            {{ scope.row.source|sourceFormat }}
          </template>
        </el-table-column>
        <el-table-column label='所属角色' prop='roleNm' align='center' show-overflow-tooltip>
          <template slot-scope='scope'>
            {{ scope.row.roleNm === null ? '--' : scope.row.roleNm }}
          </template>
        </el-table-column>
        <el-table-column label='所属部门' prop='depNm' align='center'>
          <template slot-scope='scope'>
            {{ scope.row.depNm === null ? '--' : scope.row.depNm }}
          </template>
        </el-table-column>
        <el-table-column label='状态' align='center'>
          <div slot-scope='scope'>{{ scope.row.isEnable|isEnableFormat }}</div>
        </el-table-column>
        <el-table-column label='操作' width='300' align='center'>
          <template slot-scope='scope'>
            <el-button v-if='scope.row.isEnable !== "0" && scope.row.isEnable !== "2"' size='mini'
                       type='danger' @click='disableClick(scope.row.id)'>禁用
            </el-button>
            <el-button v-if='scope.row.isEnable !== "2" && scope.row.isEnable === "0"' size='mini'
                       type='primary' @click='enableClick(scope.row.id)'>启用
            </el-button>
            <el-button size='mini' class='searchBtn' type='primary'
                       @click='detailClick(scope.row.id)'>详情
            </el-button>
            <el-button v-if='scope.row.source === "0"' size='mini' type='primary'
                       @click='changeClick(scope.row)' class='yellow-bg'>修改
            </el-button>
            <el-button v-if='scope.row.isEnable !== "2"' size='mini' type='primary'
                       @click='resetClick(scope.row.id)' class='resetBtn'>重置密码
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class='paginationContainer'>
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='sizes,prev, pager, next,jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          @prev-click='contractCurrentChange'
          @next-click='contractCurrentChange'
        />
      </div>
    </div>
    <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' width='700px' center
               @close='dialogClose' :close-on-click-modal='false'>
      <div class='depart'>
        <div-border label='基础信息' style='padding:20px 20px 10px'>
          <el-form :model='userData' label-width='110px' :rules='rules' ref='ruleForm'>
            <el-row>
              <el-col :span='24'>
                <el-form-item label='登录账号：' prop='tell' v-if="dialogTitle!=='修改用户'">
                  <el-input style='width:100%' v-model='userData.tell' placeholder='请输入登录账号'
                            autocomplete='off' size='small' />
                </el-form-item>
              </el-col>
              <el-col :span='24'>
                <el-form-item label='登录密码：' prop='password' v-if="dialogTitle!=='修改用户'">
                  <el-input style='width:100%' v-model='userData.password' placeholder='请输入登录密码'
                            autocomplete='off' size='small' show-password />
                </el-form-item>
              </el-col>
              <el-col :span='24'>
                <el-form-item label='所属部门：' prop='department'>
                  <el-select v-model='userData.department' size='small' filterable
                             style='width:100%' placeholder='请选择所属部门'>
                    <el-option v-for='item in departmentOption' :key='item.id' :label='item.depNm'
                               :value='item.id' />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='PC所属角色：' prop='PCrole'>
                  <el-select v-model='userData.PCrole' size='small' filterable style='width:100%'
                             placeholder='请选择所属角色'>
                    <el-option v-for='item in roleOption' :key='item.id' :label='item.roleNm'
                               :value='item.id' />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='APP所属角色：' prop='appRole'>
                  <el-select v-model='userData.appRole' size='small' filterable style='width:100%'
                             placeholder='请选择所属角色'>
                    <el-option v-for='item in appRoleOption' :key='item.id' :label='item.roleName'
                               :value='item.id' />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span='24'>
                <el-form-item label='员工姓名：' prop='name'>
                  <el-input style='width:100%' v-model='userData.name' placeholder='请输入用户姓名'
                            autocomplete='off' size='small' />
                </el-form-item>
              </el-col>
              <el-col :span='24'>
                <el-form-item label='服务港口：'>
                  <el-select v-model='userData.servicePort' size='small' filterable multiple
                             placeholder='请选择服务港口' style='width:100%'>
                    <el-option v-for='item in servicePortOptions' :key='item.id' :label='item.name'
                               :value='item.id'>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span='24'>
                <el-form-item label='邮箱：' prop='mail'>
                  <el-input style='width:100%' v-model='userData.mail' placeholder='请输入用户邮箱'
                            autocomplete='off' size='small' />
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='性别：'>
                  <el-radio-group v-model='userData.sex'>
                    <el-radio label='1'>男</el-radio>
                    <el-radio label='2'>女</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='年龄：'>
                  <el-input style='width:100%' v-model='userData.age' placeholder='请输入用户年龄'
                            autocomplete='off' size='small' />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div-border>
        <div class='btnContainer'>
          <el-button size='medium' class='searchBtn' :loading='addLoad' @click='addClick'>
            {{ dialogTitle === '新增用户' ? '新增' : '修改' }}
          </el-button>
          <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
        </div>
      </div>
    </el-dialog>

    <user-info ref='userInfoRef' />
    <user-new ref='userNewRef' @success='getList' />
  </div>
</template>

<script>
  import { removeSpace, getSessionStore } from '@/config/mUtils';
  import divBorder from '@/components/divBorder';
  import {
    qryEmployeeInfo,
    isEnableEmp,
    addEmployee,
    selectDepartmentAll,
    selectRoleAll,
    selectAppRoleAll,
    qryEmployeeDetail,
    editEmployee, rePasswordByUser,
  } from '@/service/basicfile';
  import { shipDeployPublicSelectPort } from '@/service/vehiclelog';
  import batchImport from '@/components/batchImport';
  import { getImport, getImportUrl } from '@/service/getIP';
  import { baseUrl } from '@/config/env';
  import UserInfo from '@/views/basicfile/system/user-components/user-info';
  import UserNew from '@/views/basicfile/system/user-components/user-new';

  export default {
    components: {
      UserNew,
      UserInfo,
      divBorder,
      batchImport,
    },
    data() {
      const validateTell = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入登录账号'));
        } else if (!(/^[1][3,4,5,7,8,9][0-9]{9}$/).test(value)) {
          callback(new Error('请输入登录账号(手机号)'));
        } else {
          callback();
        }
      };
      return {
        importLoading: false,
        defaultSearchForm: {},
        searchForm: {
          account: '',
          empNm: '',
          roleNm: '',
          depNm: '',
          source: '',
          isEnable: '',
          rows: 10,
          page: 1,
        },
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        cellStyle: {
          'color': '#7F7F7F',
          'font-size': '13px',
          'height': '52px',
        },
        sourceOption: [
          {
            id: 0,
            name: '平台',
          },
          {
            id: 1,
            name: '公路供应商',
          },
          {
            id: 2,
            name: '水路供应商',
          },
          {
            id: 3,
            name: '司机',
          },
          {
            id: 4,
            name: '船舶',
          },
        ],
        isEnableOption: [
          {
            id: '',
            name: '全部',
          },
          {
            id: 0,
            name: '禁用中',
          },
          {
            id: 1,
            name: '启用中',
          },
          {
            id: 2,
            name: '审核中',
          },
        ],
        tableLoad: false,
        tableData: [],
        total: 0,
        dialogTitle: '',
        dialogVisible: false,
        addLoad: false,
        userData: {
          password: '888888',
        },
        servicePortOptions: [],
        companyOption1: [],
        roleOption: [],
        appRoleOption: [],
        importUrl: '/essEmployee/batchAdd',//导入地址
        uploadData: {
          mFile: '',
        },

        departmentOption: [],
        rules: {
          company: [
            {
              required: true,
              message: '请选择用户所在公司',
              trigger: 'change',
            },
          ],
          name: [
            {
              required: true,
              message: '请输入用户姓名',
              trigger: 'blur',
            },
          ],
          password: [
            {
              required: true,
              message: '请输入登录密码',
              trigger: 'blur',
            },
          ],
          tell: [
            {
              required: true,
              message: '请输入登录账号',
              trigger: 'blur',
            },
            // { required: true,validator:validateTell, trigger: 'blur' },
          ],
          mail: [
            {
              type: 'email',
              message: '请输入正确的邮箱地址',
              trigger: ['blur'],
            },
          ],
          servicePort: [
            {
              required: true,
              message: '请输入服务港口',
              trigger: 'blur',
            },
          ],
          sex: [
            {
              required: true,
              message: '请选择用户性别',
              trigger: 'change',
            },
          ],
          age: [
            {
              required: true,
              message: '请输入用户年龄',
              trigger: 'blur',
            },
          ],
          PCrole: [
            {
              required: true,
              message: '请选择PC所属角色',
              trigger: 'change',
            },
          ],
          appRole: [
            {
              required: true,
              message: '请选择APP所属角色',
              trigger: 'change',
            },
          ],
          department: [
            {
              required: true,
              message: '请选择所属部门',
              trigger: 'change',
            },
          ],
        },
        detailDialogVisible: false,
        detailData: {},
        operationData: [],
      };
    },
    filters: {
      isEnableFormat(val) {
        switch (val) {
          case '0':
            return '禁用中';
          case '1':
            return '启用中';
          case '2':
            return '审核中';
        }
      },
      sourceFormat(source) {
        switch (source) {
          case null:
            return '--';
          case '0':
            return '平台';
          case '1':
            return '公路供应商';
          case '2':
            return '水路供应商';
          case '3':
            return '司机';
          case '4':
            return '船舶';
        }
      },
    },
    created() {
      // this.importUrl = getImportUrl('/essEmployee/batchAdd');
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      this.init();
    },
    methods: {
      async getList() {
        this.tableLoad = true;
        const res = await qryEmployeeInfo(this.searchForm);
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.tableData = res.data.records;
        this.total = res.data.total;
      },
      async init() {
        // this._selectDepartmentAll();
        // this._selectRoleAll();
        // this._selectAppRoleAll();
        // this._shipDeployPublicSelectPort();
        await this.getList();
      },
      // 获取港口
      async _shipDeployPublicSelectPort() {
        let res = await shipDeployPublicSelectPort();
        if (res.status !== 0) return this.$message.error(res.message);
        this.servicePortOptions = res.data.map(item => {
          return {
            name: item.supplier_name,
            id: item.id,
          };
        });
      },
      // 获取部门
      async _selectDepartmentAll() {
        let res = await selectDepartmentAll();
        if (res.status !== 0) return this.$message.error(res.message);
        this.departmentOption = res.data;
      },
      // 获取PC角色
      async _selectRoleAll() {
        let res = await selectRoleAll();
        if (res.status !== 0) return this.$message.error(res.message);
        this.roleOption = res.data;
      },
      // 获取APP角色
      async _selectAppRoleAll() {
        let res = await selectAppRoleAll();
        if (res.status !== 0) return this.$message.error(res.message);
        this.appRoleOption = res.data;
      },
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      searchBtn() {
        this.page = 1;
        this.getList();
      },
      addBtn() {
        this.$refs.userNewRef.dialogOpen('新增用户');
      },
      /**
       * 导入成功
       * @param data 分页更新数据
       */
      // 批量导入
      planOnSuccess(res) {
        // if (res.status !== 0) return this.$message.error(res.message);
        // this.$message.success(res.message);
        // this.tableData = res.data
        // this.getList();
        this.$alert(res.message, '提示', {
          confirmButtonText: '关闭',
          callback: async () => {
            this.tableData = res.data;
            await this.getList();
          },
        });
      },
      beforeUpload(file) {
        // console.log(file);
        if (file.name.split('.')[1] == 'xls' || file.name.split('.')[1] == 'xlsx') {
          this.uploadData.mFile = file.name;
        } else {
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
      //模板下载
      download() {
        window.location.href = '/file/用户管理导入模板.xlsx';

      },
      // 导出数据
      exportClick() {
        // const obj = `&orgId=${this.companyIpt}&account=${this.tellIpt}&depNm=${this.departIpt}` +
        //   `&empNm=${this.nameIpt}&roleNm=${this.roleIpt}&source=${this.source}&isEnable=${this.state}`;
        // let token = getSessionStore('token');
        window.exportExcelGet('/platform/essEmployee/userExport', `account=${this.searchForm.account}&depNm=${this.searchForm.depNm}&empNm=${this.searchForm.empNm}&roleNm=${this.searchForm.roleNm}&source=${this.searchForm.source}&isEnable=${this.searchForm.isEnable}`)
        // let url = `${baseUrl}/platform/essEmployee/userExport?access_token=${token}${obj}`;
        // window.location.href = url;
      },
      contractSizeChange(sizes) {
        this.searchForm.rows = sizes;
        this.getList();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getList();
      },
      // 详情
      detailClick(id) {
        this.$refs.userInfoRef.dialogOpen(id);
      },
      // 重置密码
      resetClick(id) {
        this.$confirm('确定要重置密码吗？重置密码后，默认密码为：666666', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await rePasswordByUser(id);
            if (res.status !== 0) {
              return this.$message.error(res.message);
            } else {
              this.$message.success(res.message);
            }
            await this.getList();
          })
          .catch(() => {
          });
      },
      // 禁用
      disableClick(id) {
        this.$confirm('确定要禁用当前用户吗？禁用后，用户将无法登录！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await isEnableEmp(id);
            if (res.status !== 0) {
              return this.$message.error(res.message);
            } else {
              this.$message.success(res.message);
            }
            await this.getList();
          })
          .catch(() => {
          });
      },
      // 启用
      enableClick(id) {
        this.$confirm('确定要启用当前用户吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await isEnableEmp(id);
            if (res.status !== 0) {
              return this.$message.error(res.message);
            } else {
              this.$message.success(res.message);
            }
            await this.getList();
          })
          .catch(() => {
          });
      },
      // 修改
      async changeClick(item) {
        this.$refs.userNewRef.dialogOpen('修改用户', item.id);
        // this._selectDepartmentAll();
        // this._selectRoleAll();
        // this._selectAppRoleAll();
        // this._shipDeployPublicSelectPort();
        // this.dialogVisible = true;
        // this.dialogTitle = '修改用户';
        const res = await qryEmployeeDetail(item.id);
        if (res.status !== 0) return this.$message.error(res.message);
        var ports = [];
        if (res.data.employeePorts) {
          for (var item of res.data.employeePorts) {
            ports.push(item.portId);
          }
        }
        this.userData = {
          ...res.data,
          company: res.data.orgId,
          name: res.data.empNm,
          tell: res.data.account,
          mail: res.data.email,
          sex: res.data.empGender,
          age: res.data.age,
          PCrole: res.data.roleId,
          appRole: res.data.appRoleId,
          department: res.data.depId,
          servicePort: ports,
        };
      },
      dialogClose() {
        this.dialogVisible = false;
        this.$refs.ruleForm.resetFields();
      },
      addClick() {
        var ports = [];
        for (var item of this.servicePortOptions) {
          //判断是否为null
          if (this.userData.servicePort) {
            for (var value of this.userData.servicePort) {
              if (item.id == value) {
                var port = {};
                port.portId = value;
                port.portName = item.name;
                ports.push(port);
              }
            }
          }
        }
        this.userData = removeSpace(this.userData);
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.addLoad = true;
            const obj = {
              id: this.userData.id,
              account: this.dialogTitle !== '修改用户' ? this.userData.tell : this.userData.account,
              depId: this.userData.department,
              empNm: this.userData.name,
              roleId: this.userData.PCrole,
              appRoleId: this.userData.appRole,
              orgId: this.userData.company,
              email: this.userData.mail,
              age: this.userData.age,
              empGender: this.userData.sex,
              employeePorts: ports,
              password: this.userData.password,
            };
            const res = this.dialogTitle === '新增用户' ? await addEmployee(obj) : await editEmployee(obj);
            this.addLoad = false;
            if (res.status !== 0) {
              return this.$message.error(res.message);
            } else {
              this.$message.success(res.message);
            }
            await this.getList();
            this.dialogClose();
            // this.dialogVisible=false;
          } else {
            return false;
          }
        });
      },
    },
  };
</script>


<style lang='scss' scoped>
  .mainContainer {
    background-color: #fff;
    width: 100%;
    padding: 20px 15px 0 25px;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin: 5px 5px 5px 0;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
      }

      .navContainer {
        width: 230px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-top: 10px;
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }

          .el-table th > .cell {
            font-weight: 700 !important;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .depart {
      width: 100%;
      padding: 20px 20px;

      ::v-deep {
        .el-form-item {
          margin-bottom: 10px;
        }

        .el-form-item__label {
          font-weight: 700;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          position: relative;
        }
      }

      hr {
        margin: 0;
        position: absolute;
        width: 100%;
        bottom: 5px;
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px 0 0px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    .permissions {
      width: 100%;
      padding: 20px 10px 20px 50px;

      .name {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          color: #2F1010;
        }
      }

      .content1 {
        p {
          color: #2F1010;
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 70vh;
      overflow: auto;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td, .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }

    ::v-deep {
      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
      }

      .el-dialog__wrapper {
        top: -10px;
      }
    }
  }

  ::v-deep {
    span i.el-icon-upload.el-icon--right {
      font-size: 16px;
      margin-left: 10px;
    }

    span.el-icon--right {
      font-size: 16px;
      cursor: pointer;
      color: rgb(51, 136, 255);
      display: flex;
      align-items: center;
      margin-left: 10px;
    }
  }
</style>
